const LOGO_URL = "https://static.readdy.ai/image/a93fb4e9fe5360734eafc891174445c0/15d05a694e2d3c4a1b130743b9c65855.jpeg";

const links = [
  { label: '課題', href: '#problem' },
  { label: '原因', href: '#root-cause' },
  { label: '解決策', href: '#solution' },
  { label: 'Before/After', href: '#before-after' },
  { label: 'サービス', href: '#service' },
  { label: '実績', href: '#trust' },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#0e0e0e' }} className="px-4 md:px-10 pt-14 pb-8">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <img src={LOGO_URL} alt="会議設計" className="h-9 w-auto object-contain rounded" />
              </div>
              <span
                className="text-sm font-bold text-white"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                会議設計
              </span>
            </div>
            <p
              className="text-sm text-white/40 leading-relaxed mb-5"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              話すだけの会議から、決まって動く会議へ。<br />
              中小企業の意思決定を、設計の力で変えます。
            </p>
            <button
              onClick={() => scrollTo('#cta')}
              className="px-5 py-2.5 bg-[#C0392B] text-white text-xs font-bold rounded-md hover:bg-[#a93226] transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
            >
              無料診断（5分）
            </button>
          </div>

          {/* Links */}
          <div>
            <h3
              className="text-xs font-bold text-white/60 uppercase tracking-widest mb-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Menu
            </h3>
            <ul className="space-y-2.5">
              {links.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-sm text-white/40 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3
              className="text-xs font-bold text-white/60 uppercase tracking-widest mb-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Contact
            </h3>
            <div className="space-y-3">
              {[
                { icon: 'ri-mail-line', text: 'kizunovationikeda@gmail.com' },
              ].map((c) => (
                <div key={c.icon} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${c.icon} text-[#C0392B] text-sm`} />
                  </div>
                  <span
                    className="text-sm text-white/40"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  >
                    {c.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/8 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p
            className="text-xs text-white/25"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            &copy; 2026 会議設計. All rights reserved.
          </p>
          <div className="flex gap-4">
            {['プライバシーポリシー', '利用規約'].map((t) => (
              <a
                key={t}
                href="#"
                rel="nofollow"
                className="text-xs text-white/25 hover:text-white/50 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
